export default __webpack_public_path__ + "static/media/ier-logo2.7f4f249e.png";